import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Set axios base URL
// Component'lerde zaten /api prefix var, baseURL boş olmalı
const isProd = process.env.NODE_ENV === 'production';
axios.defaults.baseURL = process.env.REACT_APP_API_URL || (isProd ? '' : 'http://localhost:5000');

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
